import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsRemove = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
     
      <path fill="currentColor" d="M23.541666,12.6894875H0.4583333v-1.3789749H23.541666V12.6894875z"/>
    </SvgIcon>
  );
});

export default AppIconsRemove;
